import React from 'react';
import PropTypes from 'prop-types';

import {Box, Stack, Typography} from 'views/components';
import {Translate} from 'views/module';

const CareplanTextbox = (props) => {
  const {expression, onChange, value} = props;
  const textboxValue = value || '';
  const bodyMirrorValue = `${textboxValue}\u200b`;

  return (
    <Stack spacing={0.75}>
      <Typography
        sx={{
          fontSize: '12px',
          fontWeight: 600,
          lineHeight: '150%',
          color: '#6F6A62',
        }}
      >
        <Translate expression={expression} />
      </Typography>
      <Box
        sx={{
          backgroundColor: '#FFFFFF',
          border: '1px solid #E8E4DE',
          borderRadius: '8px',
          p: '12px',
        }}
      >
        <Box
          sx={{
            position: 'relative',
          }}
        >
          <Box
            aria-hidden
            sx={{
              minHeight: '1.8em',
              visibility: 'hidden',
              fontFamily: 'inherit',
              fontSize: '13px',
              fontWeight: 400,
              lineHeight: '180%',
              whiteSpace: 'pre-wrap',
              overflowWrap: 'anywhere',
              boxSizing: 'border-box',
            }}
          >
            {bodyMirrorValue}
          </Box>
          <Box
            component='textarea'
            rows={1}
            value={textboxValue}
            onChange={(event) => {
              onChange(event.target.value);
            }}
            sx={{
              position: 'absolute',
              inset: 0,
              p: 0,
              border: 0,
              outline: 0,
              resize: 'none',
              overflow: 'hidden',
              backgroundColor: 'transparent',
              color: '#6F6A62',
              fontFamily: 'inherit',
              fontSize: '13px',
              fontWeight: 400,
              lineHeight: '180%',
              whiteSpace: 'pre-wrap',
              overflowWrap: 'anywhere',
              boxSizing: 'border-box',
            }}
          />
        </Box>
      </Box>
    </Stack>
  );
};

CareplanTextbox.propTypes = {
  expression: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
};

export default React.memo(CareplanTextbox);
